export default __webpack_public_path__ + "static/media/complementary--chevron-right--g4.651efd19.png";